import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateReanudacionCATAByID = () => {
  const [loadingUpdateReanudacionCATAById, setLoadingCreateReanudacionCATA] = useState(false);
  const [successUpdateReanudacionCATAById, setSuccessCreateReanudacionCATA] = useState(false);
  const [errorUpdateReanudacionCATAById, setErrorCreateReanudacionCATA] = useState(null);
  const [dataUpdateReanudacionCATAById, setDataReanudacionCATA] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateReanudacionCATAById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateReanudacionCATA(true);
    setSuccessCreateReanudacionCATA(false);
    setErrorCreateReanudacionCATA(null);

    apiRecord.updateSolicitudReanudacionByID(userId, formId, data).then((res: any) => {
      setLoadingCreateReanudacionCATA(false);
      setSuccessCreateReanudacionCATA(true);
      setDataReanudacionCATA(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateReanudacionCATA(false);
      setErrorCreateReanudacionCATA(err.response.data)
    })
  }

  return {
    updateReanudacionCATAById,
    loadingUpdateReanudacionCATAById,
    successUpdateReanudacionCATAById,
    errorUpdateReanudacionCATAById,
    dataUpdateReanudacionCATAById
  }

}

export default useUpdateReanudacionCATAByID;
